// Import the RTK Query methods from the React-specific entry point
import { Paths } from './paths/paths';
import { ResidenceCountry } from './response/ResidenceCountry';
import { cameliseDeep } from '@utils/functions/camelise';
import { apiSlice } from './apiSlice';

export const appDataSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    countries: builder.query<ResidenceCountry[], void>({
      query: () => Paths.ResidenceCountries,
      transformResponse: (data: unknown) =>
        cameliseDeep<ResidenceCountry[]>(data)
          ?.filter((x) => x.allowed)
          .sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          ),
    }),
  }),
});

// Export the auto-generated hook for the `getPosts` query endpoint
export const { useCountriesQuery } = appDataSlice;
